<template>
    <div>
        <no-login-header v-if="!userInfo.yhid&&!userInfo.type"></no-login-header>
        <whs-header-vue v-else-if="userInfo.yhid&&userType===1" @reloadZypg="reloadZypg"></whs-header-vue>
        <ysh-header v-else-if="userInfo.yhid&&userType===2" @reloadZypg="reloadZypg"
        @yshReadLoad="yshReadLoad"></ysh-header>
        <div class="page-component__scroll">
    <keep-alive  v-if="$route.meta.keepAlive">
      <router-view v-if="$route.meta.keepAlive" :sxkmChangeReload="sxkmChangeReload"
      :sxkmChangeReloadYxcx="sxkmChangeReload" :sxkmChangeReloadYxtj="sxkmChangeReload"
      :sxkmChangeReloadScore="sxkmChangeReload" :sxkmChangeReloadMajor="sxkmChangeReload"
      :sxkmChangeReloadDateHome="sxkmChangeReload" :zylbChangeReload="zylbChangeRead"
      :zylbChangeReloadYxcx="zylbChangeRead" :zylbChangeReloadYxtj="zylbChangeRead"
      :zylbChangeReloadScore="zylbChangeRead" :zylbChangeReloadMajor="zylbChangeRead"
      :zylbChangeReloadDateHome="zylbChangeRead" />
    </keep-alive>
     <!-- v-if="RouteState && !$route.meta.keepAlive" -->
        <router-view v-if="RouteState && !$route.meta.keepAlive" :sxkmChangeReload="sxkmChangeReload"
        :sxkmChangeReloadYxcx="sxkmChangeReload" :sxkmChangeReloadYxtj="sxkmChangeReload"
        :sxkmChangeReloadScore="sxkmChangeReload" :sxkmChangeReloadMajor="sxkmChangeReload"
        :sxkmChangeReloadDateHome="sxkmChangeReload" :zylbChangeReload="zylbChangeRead"
        :zylbChangeReloadYxcx="zylbChangeRead" :zylbChangeReloadYxtj="zylbChangeRead"
        :zylbChangeReloadScore="zylbChangeRead" :zylbChangeReloadMajor="zylbChangeRead"
        :zylbChangeReloadDateHome="zylbChangeRead" />
        </div>
        <whs-footer-vue></whs-footer-vue>
    </div>
</template>
<script>
import NoLoginHeader from '../components/noLoginHeader.vue';
import whsFooterVue from '../components/whsFooter.vue';
import whsHeaderVue from '../components/whsHeader.vue';
import YshHeader from '../components/yshHeader.vue';
import { mapState} from "vuex";
export default {
data(){
    return{
        RouteState:true,
        sxkmChangeReload:"",
        zylbChangeRead:""
    };
},
methods:{
  reloadZypg(sxkmChangeLoad){
      if(sxkmChangeLoad){
        this.sxkmChangeReload=sxkmChangeLoad;
      }
    },
    yshReadLoad(zylbchangeLoad){
      if(zylbchangeLoad){
        this.zylbChangeRead=zylbchangeLoad;
      }
    },
    reload() {
      this.RouteState = false;
      this.$nextTick(() => {
        this.RouteState = true;
      });
    },
},
provide(){
    return {
      reload: this.reload
    };
},
components:{
    whsFooterVue,
    NoLoginHeader,
    whsHeaderVue,
    YshHeader
},
computed:{
    ...mapState(["userInfo","userType"])
},
mounted(){
  let userTypeObj=localStorage.getItem("userType");
  if(userTypeObj){
    userTypeObj=JSON.parse(userTypeObj);
    this.$store.dispatch("setUserType",{type:userTypeObj.value})
  }
}
};
</script>
<style scoped lang="less">

</style>
